module.exports = __webpack_public_path__ + "img/snake-alco.34c48d55.gif";